import React from 'react';
import PropTypes from 'prop-types';
import InputInner from './InputInner';

const propTypes = {
  InputComponent: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

const InputWrapper = ({ InputComponent, ...props }) => (
  <InputComponent value={props.value} onChange={props.onChange} {...props}>
    {inputProps => <InputInner {...inputProps} />}
  </InputComponent>
);

InputWrapper.propTypes = propTypes;

export default InputWrapper;
